import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StreamScheduleService, StreamEvent } from '../services/stream-schedule.service';

@Component({
  selector: 'app-events-list-overlay',
  templateUrl: './events-list-overlay.component.html',
  styleUrls: ['./events-list-overlay.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class EventsListOverlayComponent implements OnInit {
  private scheduleService = inject(StreamScheduleService);
  events = this.scheduleService.getEvents();

  ngOnInit() {
    this.scheduleService.loadEvents();
  }

  formatDateTime(datetime: string): string {
    const date = new Date(datetime);
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).format(date);
  }

  getIconUrl(event: StreamEvent): string {
    return event.overlay_icon;
  }
}